import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {CustomInputs} from '../../../../../../../_metronic/helpers/components/CustomInputs'
import {InvoiceNetPrice} from './InvoiceNetPrice'
import {UploadedFile} from '_metronic/helpers/components/uploadTypes'
import {SearchSelectOption} from '../../../../../../../_metronic/helpers/components/SearchSelect'
import axios from 'axios'
import {API_URL} from '../../../../../../../_metronic/helpers'
import {ICompanytemplate} from '../../../../taxpayer-management/taxpayers-setting/_models'
import {useAuth} from '../../../../../auth'
import {InvoiceRulesV79, isInvoiceFieldVisible} from '../../core/invoiceRulesV79'
import {InvoiceNotesV79Fields} from './InvoiceNotesV79Fields'
import {AutoOpenOptionalSection} from '../AutoOpenOptionalSection'
import {shouldOpenStep4OptionalSection} from './step4OptionalSection'
import {FieldHelpLabel} from '../../../../../../../_metronic/helpers/components/FieldHelp'

type props = {
  description: {
    description: string
    setDescription: Dispatch<SetStateAction<string>>
  }
  files: {
    files: UploadedFile[]
    setFiles: Dispatch<SetStateAction<UploadedFile[]>>
  }
  isSend: {
    isSend: boolean
    setIsSend: Dispatch<SetStateAction<boolean>>
  }
  vatCheck: {
    vatCheck: string
    setVatCheck: Dispatch<SetStateAction<string>>
  }
  printTemplate: {
    printTemplate: number | undefined
    setPrintTemplate: Dispatch<SetStateAction<number | undefined>>
  }
  getSumPayments: () => number
  getSumNetPrice: () => number
  invoiceDate: string
  isNew: boolean
  showVatRateValidationQuestion: boolean
  rules?: InvoiceRulesV79
  notes: {
    note1: string
    setNote1: (value: string) => void
    note2: string
    setNote2: (value: string) => void
  }
  readOnly?: boolean
}
const Step4: FC<props> = ({
  description,
  getSumNetPrice,
  files,
  printTemplate,
  isSend,
  vatCheck,
  isNew,
  showVatRateValidationQuestion,
  rules,
  notes,
  readOnly,
}) => {
  const [templateOptions, setTemplateOptions] = useState<ICompanytemplate[]>([])
  const [templateItems, setTemplateItems] = useState<SearchSelectOption[]>([])
  const {currentUser} = useAuth()
  const valueAddedNotCalled =
    currentUser?.cpl?.find((company) => company.id === currentUser.cpi)?.vnc === true
  const selectedVatCheck = vatCheck.vatCheck
  const setSelectedVatCheck = vatCheck.setVatCheck
  useEffect(() => {
    axios.get(`${API_URL}/taxpayer/printTemplate/`).then((response) => {
      setTemplateOptions(response.data)
    })
  }, [])

  useEffect(() => {
    if ((!showVatRateValidationQuestion || valueAddedNotCalled) && selectedVatCheck !== '1') {
      setSelectedVatCheck('1')
    }
  }, [showVatRateValidationQuestion, valueAddedNotCalled, selectedVatCheck, setSelectedVatCheck])

  useEffect(() => {
    let _templateItems: SearchSelectOption[] = []
    templateOptions.forEach((itm) => {
      _templateItems.push({
        label: itm.name,
        value: itm.id,
      })
    })
    setTemplateItems(_templateItems)
  }, [templateOptions])

  const showSupplementaryNotes =
    isInvoiceFieldVisible(rules, 'nti1', false) || isInvoiceFieldVisible(rules, 'nti2', false)
  const canSelectDirectSend =
    currentUser !== undefined && currentUser.rl !== undefined && currentUser.rl <= 100 && isNew
  const showVatQuestion = showVatRateValidationQuestion && !valueAddedNotCalled

  return (
    <>
      <div className='row'>
        <div className='col-12'>
          <AutoOpenOptionalSection
            title='اطلاعات اختیاری'
            hasValue={shouldOpenStep4OptionalSection(
              printTemplate.printTemplate,
              templateOptions,
              description.description,
              files.files.length
            )}
          >
            <div className='row'>
              <div className='col-12 mt-5'>
                <CustomInputs
                  label='قالب صورتحساب چاپی خود را تعیین کنید'
                  type='select'
                  items={templateItems}
                  stateValue={{
                    value: printTemplate.printTemplate,
                    setValue: printTemplate.setPrintTemplate,
                  }}
                />
              </div>
              {printTemplate.printTemplate &&
                printTemplate.printTemplate > 0 &&
                templateOptions.find((x) => x.id === Number(printTemplate.printTemplate))
                  ?.description && (
                  <div className='col-12 mt-4 mb-3'>
                    <h4 className='fs-6'>
                      <FieldHelpLabel
                        label='شرح ثابت داخل باکس توضیحات صورتحساب'
                        helpKey='ui.printTemplate'
                      />
                    </h4>
                    <p style={{whiteSpace: 'pre-line'}}>
                      {
                        templateOptions.find((x) => x.id === Number(printTemplate.printTemplate))
                          ?.description
                      }
                    </p>
                  </div>
                )}
              <div className='col-12 mt-7'>
                <CustomInputs
                  type='textarea'
                  label='سایر توضیحات صورتحساب'
                  hint={
                    <span className='text-gray-600 fs-7'>
                      <i className='las la-info text-info fs-5'></i>
                      فقط جهت نمایش در انتهای صورتحساب چاپی
                    </span>
                  }
                  stateValue={{
                    value: description.description,
                    setValue: description.setDescription,
                  }}
                />
              </div>
              <div className='col-12 mt-5'>
                <CustomInputs
                  label='مستندات و ضمائم'
                  uploaderProps={{
                    label: 'مستندات',
                    allowMultiple: true,
                    maxFiles: 5,
                    files: files.files,
                    setFiles: files.setFiles,
                    acceptedFileTypes: ['image/*', 'application/pdf', 'text/plain'],
                  }}
                  type='uploader'
                />
              </div>
            </div>
          </AutoOpenOptionalSection>
        </div>
        {showSupplementaryNotes && (
          <div className='col-12'>
            <AutoOpenOptionalSection
              title='یادداشت‌های تکمیلی'
              hasValue={notes.note1.trim().length > 0 || notes.note2.trim().length > 0}
            >
              <div className='row'>
                <InvoiceNotesV79Fields
                  rules={rules}
                  note1={notes.note1}
                  setNote1={notes.setNote1}
                  note2={notes.note2}
                  setNote2={notes.setNote2}
                  readOnly={readOnly}
                />
              </div>
            </AutoOpenOptionalSection>
          </div>
        )}
        <div className='col-12 mt-5 px-3'>
          <InvoiceNetPrice getSumNetPrice={getSumNetPrice} />
        </div>
        {(showVatQuestion || canSelectDirectSend) && (
          <div className='col-12 mt-5'>
            {showVatQuestion && (
              <div className='rounded border border-dashed border-warning bg-light-warning p-5 mb-5'>
                <CustomInputs
                  type='radio'
                  isVertical
                  label='نرخ مالیات بر ارزش افزوده یک یا چند قلم را تغییر داده‌اید. آیا پیش از ثبت، نرخ‌های واردشده با نرخ مرجع شناسه کالا/خدمت کنترل شوند؟'
                  helpKey='ui.vatRateCheck'
                  items={[
                    {
                      label:
                        'بله، نرخ‌ها کنترل شوند؛ در صورت مغایرت، صورتحساب ثبت نمی‌شود و خطا نمایش داده می‌شود.',
                      value: 1,
                    },
                    {
                      label: 'خیر، صورتحساب با همین نرخ‌های واردشده ثبت شود.',
                      value: 2,
                    },
                  ]}
                  stateValue={{
                    value: vatCheck.vatCheck,
                    setValue: vatCheck.setVatCheck,
                  }}
                />
              </div>
            )}
            {canSelectDirectSend && (
              <CustomInputs
                label='ارسال مستقیم صورتحساب به سازمان امور مالیاتی (سامانه مؤدیان)'
                isVertical
                type='toggle'
                stateValue={{
                  value: isSend.isSend,
                  setValue: isSend.setIsSend,
                }}
                hint='مقدار اولیه از تنظیم روش ورود همین فرم گرفته شده است؛ تغییر آن فقط روی همین صورتحساب اثر دارد.'
              />
            )}
          </div>
        )}
      </div>
    </>
  )
}

export {Step4}
